<template>
    <div class="sntopbar">
        <div class="row p-2">
            <div class="col-md-2"><img style="height: 75px;" src="img/bucher.jpg" /></div>
            <div class="col-md-6"><h3 class="mt-2">Gestione corsi</h3></div>
            <div class="col-md-4"><messaggio-globale fontawesome="standard"></messaggio-globale></div>
        </div>
        <div class="row sntopbarmenu">
            <div class="col-md-12 text-center">
                <router-link to="/dashboard" class="me-2 ms-2">
                    Bacheca
                </router-link>-
                <router-link to="/dati-aziendali" class="me-2 ms-2">
                    Dati aziendali
                </router-link>-
                <router-link to="/corsi" class="me-2 ms-2">
                    Corsi
                </router-link>-
                <router-link to="/personale" class="me-2 ms-2">
                    Personale
                </router-link>-
                
                <a class="me-2 ms-2" href="#" @click="DoLogout">Esci</a>
            </div>
            
        </div>
    </div>
   
    
</template>

<script>
import MessaggioGlobale from "@/components/MessaggioGlobale.vue";

export default {
    name: "TopbarElement",
    components: { MessaggioGlobale },
    inject: ['cfg'],
    methods: {

        DoLogout() {
            if(confirm('Vuoi scollegarti?')) {
                //this.$store.commit('Messaggio', {parms: [true, ['Logout in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});

                this.$store.commit('UserInfo',{ token: "" });
                this.$router.push("/");  

            }
        },

        
    }
}
</script>

<style scoped>
    .sntopbar {
        overflow: hidden;
        background-color: #CC3731;
        position: fixed;
        top: 0;
        width: 100%;
        height: 130px;
        color: #fff;
        text-align: left;
        /*padding: 2px 2px 2px 20px;*/
        z-index:100;
    }
    .sntopbarmenu {
        width: 100%;
        height: 50px;
        background-color: #333;
        color:#fff;

        padding-top: 10px;

    }
    .sntopbarmenu a {
        text-decoration: none;
        color:antiquewhite;
    }
    .sntopbarmenu a:hover {
        background-color:#444;
    }

   
</style>
